import React, { useState } from 'react';
import { makeStyles, Typography, Tabs, Tab, Box } from '@material-ui/core';
import LabSamplesTable from 'components/business/lab/LabSamplesTable';
import LabCompletedSamplesTable from 'components/business/lab/LabCompletedSamples';

export const LabCtx = React.createContext({});

const useStyles = makeStyles((theme) => {
  return {
    tabRoot: {
      marginLeft: '8px',
      textTransform: 'none',
      backgroundColor: '#ffffff',
      fontSize: '16px',
      color: theme.palette.secondary.dark,
      border: '1px solid #ccc',
      minWidth: 180,
      '&:hover': {
        color: '#ffffff',
        backgroundColor: theme.palette.secondary.light,
        opacity: 1,
      },
      '&$tabSelected': {
        color: '#ffffff',
        backgroundColor: theme.palette.secondary.dark,
        fontWeight: 'bold',
        fontSize: '18px',
      },
    },
    tabSelected: {},
  };
});

// for tabs selection
function a11yProps(index) {
  return {
    id: `simple-tab-${ index }`,
    'aria-controls': `simple-tabpanel-${ index }`,
  };
}

// Function for Tabs
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={ value !== index }
      id={ `simple-tabpanel-${ index }` }
      aria-labelledby={ `simple-tab-${ index }` }
      { ...other }
    >
      {value === index && (
        <Box p={ 3 }>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function LabPageProvider(props) {
  const ctx = {
  };
  return (
    <LabCtx.Provider value={ ctx }>
      {props.children}
    </LabCtx.Provider>
  );
}

function LabSamplesPage() {
  const classes = useStyles();
  const [ tab, setTab ] = useState(0);

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <LabPageProvider>
      <Box pt={ 2 }>
        <Tabs
          className={ classes.customTabs }
          value={ tab }
          onChange={ handleChange }
          aria-label='Lab tabs'
          indicatorColor='primary'
          textColor='rgb(100, 141, 174)'
        >
          <Tab
            label='Lab Samples'
            { ...a11yProps(0) }
            classes={ { root: classes.tabRoot, selected: classes.tabSelected } }
          />
          <Tab
            label='Completed Samples '
            { ...a11yProps(1) }
            classes={ { root: classes.tabRoot, selected: classes.tabSelected } }
          />
        </Tabs>
        <TabPanel value={ tab } index={ 0 }>
          <LabSamplesTable />
        </TabPanel>
        <TabPanel value={ tab } index={ 1 }>
          <LabCompletedSamplesTable />
        </TabPanel>

      </Box>
    </LabPageProvider>
  );
}

export default LabSamplesPage;
